import { DropdownDTO } from "../../../types/common/DropdownDTO";

/**
 * 🟡 Temporal — Fake Solo para desarrollo.
 * Luego lo reemplazamos cuando implementemos /api/users/dropdown
 */
export const fakeCreatedByDropdown: DropdownDTO[] = [
  { id: 1, name: "admin" },
  { id: 2, name: "support" },
  { id: 3, name: "accounting" },
];
